import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Splash() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/auth');
    }, 2500);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gradient-to-br from-[#0D47A1] via-[#1976D2] to-[#FF8F00] overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute w-96 h-96 bg-white/10 rounded-full -top-20 -left-20 animate-pulse"></div>
        <div className="absolute w-80 h-80 bg-white/10 rounded-full -bottom-20 -right-20 animate-pulse delay-300"></div>
      </div>

      {/* Logo Container */}
      <div className="relative z-10 flex flex-col items-center animate-fade-in">
        {/* Logo Icon */}
        <div className="w-32 h-32 bg-white rounded-3xl shadow-2xl flex items-center justify-center mb-6 animate-bounce-slow">
          <i className="ri-shopping-basket-2-fill text-6xl text-[#0D47A1]"></i>
        </div>

        {/* App Name */}
        <h1 className="text-white text-3xl font-bold text-center px-8 mb-2 animate-slide-up" style={{ fontFamily: 'Cairo, sans-serif' }}>
          طلبات الجملة والتجزئة
        </h1>
        
        {/* Tagline */}
        <p className="text-white/90 text-base text-center px-8 animate-slide-up delay-200" style={{ fontFamily: 'Cairo, sans-serif' }}>
          توصيل سريع وموثوق
        </p>

        {/* Loading Indicator */}
        <div className="mt-12 flex gap-2">
          <div className="w-2 h-2 bg-white rounded-full animate-bounce"></div>
          <div className="w-2 h-2 bg-white rounded-full animate-bounce delay-100"></div>
          <div className="w-2 h-2 bg-white rounded-full animate-bounce delay-200"></div>
        </div>
      </div>

      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes bounce-slow {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        .animate-fade-in {
          animation: fade-in 1s ease-out;
        }

        .animate-slide-up {
          animation: slide-up 0.8s ease-out;
        }

        .animate-bounce-slow {
          animation: bounce-slow 2s ease-in-out infinite;
        }

        .delay-100 {
          animation-delay: 0.1s;
        }

        .delay-200 {
          animation-delay: 0.2s;
        }

        .delay-300 {
          animation-delay: 0.3s;
        }
      `}</style>
    </div>
  );
}